import { render, staticRenderFns } from "./Redirector.vue?vue&type=template&id=b02d09b2&scoped=true&"
import script from "./Redirector.vue?vue&type=script&lang=js&"
export * from "./Redirector.vue?vue&type=script&lang=js&"
import style0 from "./Redirector.vue?vue&type=style&index=0&id=b02d09b2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b02d09b2",
  null
  
)

export default component.exports